import { render, staticRenderFns } from "./AssetDialog.vue?vue&type=template&id=40ba1996&scoped=true"
import script from "./AssetDialog.vue?vue&type=script&lang=js"
export * from "./AssetDialog.vue?vue&type=script&lang=js"
import style0 from "./AssetDialog.vue?vue&type=style&index=0&id=40ba1996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ba1996",
  null
  
)

export default component.exports